<template>
  <v-layout class="pa-12" text-center wrap>
    <v-flex xs12 sm12 lg5 md5>
      <ListOccurrences></ListOccurrences>
    </v-flex>
    <v-flex xs12 sm12 lg7 md7>
      <v-card
        class="mt-xs-8 mt-sm-5 mt-lg-0 mt-md-0 ml-lg-4 ml-md-4 elevation-2"
        :style="$vuetify.breakpoint.name == 'xs' ? 'margin-top:16px' : ''"
        :height="
          $vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'
            ? '800'
            : '530'
        "
      >
        <v-tabs
          v-model="currentItem"
          class="elevation-0 mb-0"
          color="teal accent-3"
          style="height: 104%"
          grow
        >
          <v-tab
            :href="`#tab-solicitacao`"
            :disabled="disabledTabSolicitation"
            width="100"
          >
            Solicitação
          </v-tab>
          <v-tab :href="`#tab-paciente`" :disabled="disabledTabPatient">
            Paciente
          </v-tab>
          <v-tabs-items
            class="pb-0"
            v-model="currentItem"
            :style="
              $vuetify.breakpoint.name == 'sm' ||
              $vuetify.breakpoint.name == 'xs'
                ? ' height:93%'
                : 'height:90%'
            "
          >
            <v-tab-item :value="'tab-solicitacao'" style="height: 104%">
              <StepSolicitacao ref="stepSolicitation"></StepSolicitacao>
            </v-tab-item>
            <v-tab-item :value="'tab-paciente'" class="mb-3">
              <StepPatient ref="StepPatient"></StepPatient>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
        <v-card class="mt-5 text-right elevation-1">
          <v-container class="px-5">
            <v-btn
              class="body-2 white--text mr-5"
              @click="previousStep"
              color="primary"
              v-if="currentItem !== 'tab-solicitacao'"
              depressed
            >
              <v-icon>arrow_back</v-icon>Voltar
            </v-btn>
            <v-btn
              v-if="currentItem === 'tab-paciente'"
              color="primary"
              :loading="loading"
              @click="newTarm"
            >
              Enviar
            </v-btn>
            <v-btn
              v-else
              class="body-2 white--text"
              @click="nextStep"
              color="primary"
              depressed
            >
              Seguir
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-container>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mask } from "vue-the-mask";
import ListOccurrences from "../../components/shared/ListOccurrences";
import StepSolicitacao from "../../components/shared/StepSolicitation";
import StepPatient from "../../components/shared/StepPatient";
var moment = require("moment-timezone");

export default {
  name: "TarmCalls",
  directives: {
    mask,
  },
  components: {
    /*  Gmaps, */
    ListOccurrences,
    StepSolicitacao,
    StepPatient,
  },

  data: () => ({
    currentItem: "tab-solicitacao",
    disabledTabSolicitation: false,
    disabledTabPatient: true,
    success: false,
    loading: false,
  }),
  mounted() {
    this.$store.dispatch("loadAttendances");
    var channel = this.$pusher.subscribe("my-channel");
    channel.bind("my-event", () => {
      this.$store.dispatch("loadAttendances");
    });
  },

  created() {},

  computed: {
    user() {
      return this.$store.getters.user;
    },
  },

  watch: {
    user() {
      var value = this.user;
      if (!value) {
        this.$router.push("/");
      }
    },

    sockets() {},
  },

  methods: {
    load() {
      return this.attendances;
    },

    solicitacaoValid() {
      return (
        this.nome !== "" &&
        this.telefone !== "" &&
        this.typeClassification !== "" &&
        this.reasonClassification !== ""
      );
    },

    nextStep() {
      this.tabPaciente = false;
      this.tabSolicitacao = true;

      this.$nextTick(() => {
        switch (this.currentItem) {
          case "tab-solicitacao":
            //if(this.solicitacaoValid())
            var valid = this.$refs.stepSolicitation.setSolicitationInfoCall();
            console.log("Valid em tab-solicitacao", valid);
            if (this.$refs.stepSolicitation.setSolicitationInfoCall()) {
              this.currentItem = "tab-paciente";
              this.disabledTabSolicitation = true;
              this.disabledTabPatient = false;
            }
            break;
        }
      });
    },

    previousStep() {
      this.$nextTick(() => {
        switch (this.currentItem) {
          case "tab-paciente":
            this.currentItem = "tab-solicitacao";
            this.disabledTabSolicitation = false;
            this.disabledTabPatient = true;
            break;
        }
      });
    },

    logOut() {
      this.$store.dispatch("logOut");
    },

    reset() {
      this.success = false;
    },

    async newTarm() {
      if (this.$refs.StepPatient.setVictimsInfoCall()) {
        this.loading = true;
        let call = this.$store.getters.call;
        let pacientes = call && call.victims ? call.victims : [];
        const tudoOK = { error: undefined };
        for (let i = 0; i < pacientes.length; i++) {
          let paciente = pacientes[i];
          let retorno = await this.$store
            .dispatch("newTarm", paciente)
            .then((response) => {
              tudoOK.response = response;
              console.log("Success created newTarm with paciente =", paciente);
            })
            .catch((e) => {
              tudoOK.error = e;
              console.log(
                "Error created newTarm with paciente =",
                paciente,
                "\nerror.message =",
                e.message
              );
            });
        }

        await this.$store.dispatch("loadAttendances");
        this.clearAttendance();
        this.currentItem = "tab-solicitacao";
        this.disabledTabSolicitation = false;
        this.disabledTabPatient = true;
        this.loading = false;
        if (tudoOK.error) {
          console.log(tudoOK);
        } else {
          location.reload();
        }
      }
    },

    clearAttendance() {
      this.success = false;
      this.$refs.stepSolicitation.clearStep();
      this.$refs.StepPatient.clearStep();
    },
  },
};
</script>

<style scoped>
.not-uppercase {
  text-transform: none;
}
</style>
